export const blockIconsHomeProductivityNew = (
	<span className='material-symbols-outlined'>productivity</span>
);
